module.exports = __webpack_public_path__ + "img/bg1.3c925ca3.webp";